<template>
  <div>
    <b-container fluid class="mt-3">
      <b-row>
        <b-col>
          <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 border-bottom border-light">
            <h5>データ管理</h5>
            <div class="d-flex float-right">
              <!-- <h5 class="text-secondary"><b-badge variant="light">最終更新 : 2022/05/01 11:22:33</b-badge></h5>
              <b-button size="sm" class="mb-2" variant="outline-secondary">
                データを更新する<b-icon icon="arrow-clockwise" aria-label="Help" class="ml-1"></b-icon>
              </b-button> -->
            </div>
          </div>

        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card no-body class="shadow-sm">
            <b-tabs card>
              <b-tab active>
                <template #title>
                  <div class="text-dark">ルートデータベース エクスポート</div>
                </template>
                <b-row class="text-center">
                  <b-col>
                    <b-button disabled variant="info"><b-icon icon="cloud-download" aria-label="Help" class="mr-1"></b-icon>ルートデータベースダウンロード</b-button>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab>
                <template #title>
                  <div class="text-dark">ステーションデータベース インポート</div>
                </template>
                <b-row>
                  <b-col>
                    <b-card title="家庭ごみステーション インポート">
                      <b-input-group>
                        <template #prepend>
                          <b-input-group-text >ステーション情報 GeoJSONファイル</b-input-group-text>
                        </template>
                        <b-form-file id="household-import" placeholder="ファイルが選択されていません" browse-text="参照" accept=".geojson"></b-form-file>
                        <b-input-group-append>
                          <b-button variant="info">インポート開始</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-card>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <b-card title="資源ごみステーション インポート">
                      <b-input-group>
                        <template #prepend>
                          <b-input-group-text >ステーション情報 GeoJSONファイル</b-input-group-text>
                        </template>
                        <b-form-file id="recycle-import" placeholder="ファイルが選択されていません" browse-text="参照" accept=".geojson"></b-form-file>
                        <b-input-group-append>
                          <b-button variant="info">インポート開始</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-card>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>

    </b-container>

  </div>
</template>

<script>
export default {
  data() {
    return {
      value : ""
    }
  },
  // Initialized Event & Lifecycle
  beforeCreate() {
  },
  // Initialized Injection & Reactivity
  created() {
  },
  // Processed the following
  beforeMount() {
    // 1.Has "el" option?
    //   Yes  -> No action
    //   No   -> vm.&mount(el) is called.
    // 2.Has "template" option?
    //   Yes  -> Compile template into render function.
    //   No   -> Compile el's outerHTML as template
  },
  // Created vm.$el and replaced "el" with it.
  mounted() {
  },
  // Data changed in mounted state.
  beforeUpdate() {
  },
  // Virtual DOM re-rendered and patched in mounted state.
  updated() {
  },
  // vm.$destroy() is called.
  beforeUnmount() {
  },
  // Teardown completed watchers, child components and event listeners
  unmounted() {
  },
  computed: {
    // Getter of ...
  },
  watch: {
  },
  methods:{
  }
}
</script>
